import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { pretendChild } from '@app/actions/parents'

class PretendLink extends Component {
  constructor(props) {
    super(props)
    this.handlePretend = this.handlePretend.bind(this)
  }

  handlePretend(_) { this.props.pretendChild(this.props.id) }

  render() {
    const { children, pretendChild, ...props } = this.props
    return (
      <a href="javascript:void(0)" onClick={this.handlePretend} {...props}>
        { children }
      </a>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return { pretendChild: bindActionCreators(pretendChild, dispatch) }
}

PretendLink.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
}

export default connect(null, mapDispatchToProps)(PretendLink)
